
























































































import Vue from "vue";
import GameScreen from "./GameScreen";
export default GameScreen;
